import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderOpen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFolderOpen"><Path fillRule="evenodd" clipRule="evenodd" d="M10.5352 3H2V20H19.9852L23.111 10H21V6H12.5352L10.5352 3ZM19 10V8H11.4648L9.46482 5H4V18H4.76481L7.26481 10H19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolderOpen;
